<template>
  <div id="esct-rates">
    <el-row>
      <el-col :span="12">
        <p>Employer Superannuation Contribution Tax (ESCT)</p>
      </el-col>
      <el-col :span="12">
        <el-button
          size="mini"
          class="right"
          type="danger"
          plain
          style="margin-left: 10px;"
          @click="delete_last_time_frame()"
        >
          Delete latest time frame
        </el-button>
        <el-button
          size="mini"
          class="right"
          type="primary"
          plain
          @click="show_dialog = true"
        >
          New Esct Rates
        </el-button>
      </el-col>
    </el-row>
    <el-collapse v-model="active_names">
      <el-collapse-item
        v-for="(time,index) in esct_rates"
        :key="time.id"
        :name="index"
        :title="time.start + ' - ' + (time.ends || 'open')"
      >
        <el-table
          :data="time.esct_rates"
        >
          <el-table-column
            prop="from_amount"
            label="From amount"
          >
            <template #default="scope">
              <money :amount="scope.row.from_amount" />
            </template>
          </el-table-column>
          <el-table-column
            prop="to_amount"
            label="To amount"
          >
            <template #default="scope">
              <money :amount="scope.row.to_amount" />
            </template>
          </el-table-column>
          <el-table-column
            prop="rate"
            label="Rate %"
          />
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      title="New Esct Rates"
      :visible.sync="show_dialog"
      width="30%"
      @opened="set_default_input()"
    >
      <el-form
        ref="esct_rate"
        :model="esct_rate"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item
          label="Start esct period"
          prop="start"
          required
        >
          <el-date-picker
            v-model="esct_rate.start"
            placeholder="Start esct period"
            format="dd.MM.yyyy"
            size="small"
            type="datetime"
          />
        </el-form-item>
        <el-form-item
          label="From amount"
          required
          prop="from_amount"
        >
          <el-input
            v-model="esct_rate.from_amount"
            placeholder="From amount"
            size="small"
          />
        </el-form-item>
        <el-form-item
          label="To amount"
          prop="to_amount"
          required
        >
          <el-input
            v-model="esct_rate.to_amount"
            placeholder="To amount"
            size="small"
          />
        </el-form-item>
        <el-form-item
          label="Rate %"
          prop="rate"
          required
        >
          <el-input-number
            v-model="esct_rate.rate"
            size="small"
            :precision="2"
            :step="0.5"
            :max="100"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="create_esct_rates"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {timeframe_esct_rates, create_esct_rates, delete_timeframe_esct_rates} from '../../api/esct_rates';
import Money from '../shared/Money';
export default {
  name: 'EsctRates',
  components: {Money},
  data() {
    return {
      esct_rates: [{id: '', start: '', ends: ''}],
      esct_rate: { start: '', from_amount: '', to_amount: '', rate: 10 },
      show_dialog: false,
      timeframe: [],
      rules: {
        start: [{ required: true, message: ' ' }],
        from_amount: [{ required: true, message: ' ', trigger: 'blur' }],
        to_amount: [{ required: true, message: ' ', trigger: 'blur' }],
        rate: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      active_names: [0]
    };
  },
  created() {
    this.timeframe_esct_rates();
  },
  methods: {
    timeframe_esct_rates(){
      timeframe_esct_rates(this).then((response)=> {
        this.esct_rates = response.data;
      });
    },
    create_esct_rates(){
      this.$refs['esct_rate'].validate((valid) => {
        if (valid) {
          create_esct_rates(this, this.esct_rate).then((response) => {
            this.$message({
              type: 'success',
              message: response.data.message
            });
            this.timeframe_esct_rates();
          });
        }
      });
    },
    delete_last_time_frame(){
      delete_timeframe_esct_rates(this).then((response)=> {
        this.$message({
          type: 'success',
          message: response.data.message
        });
        this.timeframe_esct_rates();
      });
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style scoped>
#esct-rates /deep/ .el-dialog {
  width: 550px !important;
}
#esct-rates /deep/ .el-input{
  width: inherit;
}
</style>